const e = {
  name: "Bank",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M40,11.4L20,0L0,11.4V17h4v16H2.6L0,35.6V40h40v-4.4L37.4,33H36V17h4V11.4z M2,12.6L20,2.3l18,10.3V15H2V12.6
			z M24,33V17h4v16H24z M3.4,35h33.2l1.4,1.4V38H2v-1.6L3.4,35z M30,33V17h4v16H30z M22,33h-4V17h4V33z M12,17h4v16h-4V17z M10,33H6
			V17h4V33z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Bank
};
